import request from '@/utils/sap-request'

// 生产计划查询
export const apiGetProdPlanList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/prodplan01',
    method: 'POST',
    data
  })
}

// 生产计划详情
export const apiGetProdDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/prodplan001',
    method: 'POST',
    data
  })
}

// 生产计划汇总查询
export const apiGetProdSumList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/masterdata/prodplan02',
    method: 'POST',
    data
  })
}

// 生产计划汇总确认查询
export const apiGetProdSumConfirmList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan10',
    method: 'POST',
    data
  })
}

// 生产计划汇总处理查询
export const apiGetProdSumHandleList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan06',
    method: 'POST',
    data
  })
}

// 生产计划汇总处理汇总确认
export const apiGetProdSumHandleSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan09',
    method: 'POST',
    data
  })
}

// 生产计划最总确认
export const apiProdSumHandleLastConfirm = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan11',
    method: 'POST',
    data
  })
}

// 生产计划行项目保存（计算吨）
export const apiHandleProdItem = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan05',
    method: 'POST',
    data
  })
}

// 生产计划单保存
export const apiHandleProdSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan03',
    method: 'POST',
    data
  })
}

// 生产计划单提交
export const apiHandleProdSub = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan003',
    method: 'POST',
    data
  })
}

// 生产计划单撤回
export const apiHandleProdRevocation = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan13',
    method: 'POST',
    data
  })
}

// 生产计划单后续订单
export const apiHandleProdFollowOrder = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/prodplan_order',
    method: 'POST',
    data
  })
}

// 生产计划单后续订单
export const apiHandleGetProVers = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_pro_vers',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/sap/make-plan.js